export enum UserProfileMenuVariant {
    DESKTOP = "desktop",
    MOBILE = "mobile"
}
export enum UserProfileMenuVariant {
    DESKTOP = "desktop",
    MOBILE = "mobile"
}
